<template>
    <div>
        <div class="flex flex-wrap flex-lg-nowrap lg:justify-between">
            <div class="text-2xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Lists</div>
            <button>
                <a href="/lists/create" class="hidden xl:inline border-2 border-teal bg-teal font-semibold p-2 text-white text-sm rounded-sm">
                    Create List
                </a>
            </button>
        </div>
        <div v-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>

        <div v-else>
            <div v-if="lists.length > 0">
                <div class="bg-white shadow-md rounded mb-6 mt-4 overflow-auto">
                    <table class="text-left w-full border-collapse" id="list_index">
                        <thead>
                        <tr class="font-bold uppercase text-sm text-grey-darkest">
                            <th class="pl-2">
                                <button
                                    class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                    :class="currentOrder.sortBy === 'name' ? 'text-teal' : ''"
                                    @click="sortByColumn('name')">
                                    Name
                                    <i class="fa fa-xs ml-2"
                                       :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                       v-if="currentOrder.sortBy === 'name'"></i>
                                </button>
                            </th>
                            <th class="pl-2">
                                <button
                                    class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                    :class="currentOrder.sortBy === 'object_type' ? 'text-teal' : ''"
                                    @click="sortByColumn('object_type')">
                                    Object
                                    <i class="fa fa-xs ml-2"
                                       :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                       v-if="currentOrder.sortBy === 'object_type'"></i>
                                </button>
                            </th>
                            <th class="pl-2">
                                <button
                                    class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                    :class="currentOrder.sortBy === 'updated_at' ? 'text-teal' : ''"
                                    @click="sortByColumn('updated_at')">
                                    Last Updated
                                    <i class="fa fa-xs ml-2"
                                       :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                       v-if="currentOrder.sortBy === 'updated_at'"></i>
                                </button>
                            </th>
                            <th class="pl-2">
                                <button
                                    class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                    :class="currentOrder.sortBy === 'creator' ? 'text-teal' : ''"
                                    @click="sortByColumn('creator')">
                                    Creator
                                    <i class="fa fa-xs ml-2"
                                       :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                       v-if="currentOrder.sortBy === 'creator'"></i>
                                </button>
                            </th>
                            <th class="pl-2 border-l-1" style="width:5%"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in lists" class="text-sm">
                            <td class="pl-2 md:table-cell">{{item.name}}</td>
                            <td class="pl-2 md:table-cell">{{item.object_type}}</td>
                            <td class="pl-2 md:table-cell">{{fixUpdatedDate(item.last_updated)}}</td>
                            <td class="pl-2 md:table-cell">{{item.creator}}</td>
                            <td class="px-4 text-right hidden md:table-cell border-l-1 cursor-pointer" @click="listDetail(item)">
                                <span class="material-icons">chevron_right</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-else class="mt-10 text-center">
                <div class="flex-col">
                    <div>
                        <img width="400" src="/images/blank.svg">
                    </div>
                    <div class="mt-4">
                        <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                            <div class="text-xl w-1/4 tracking-wide">You haven't created a list yet!</div>
                        </div>
                        <a href="/lists/create" class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">Click here to add your first list!</a>
                    </div>
                </div>
            </div>


            <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center align-items-center">
                <div class="mr-3">
                    Total of {{ pagination.meta.total }} records
                </div>

                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                >
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'list-index',
    data() {
        return {
            page: 1,
            currentOrder: {
                sortBy: 'updated_at',
                direction: 'desc'
            },
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            data_loading: true,
            lists: [],
        }
    },
    created() {
        this.fetchLists();
    },
    methods: {
        goToPage(page) {
            this.page = page;
            this.fetchLists(this.page);
        },
        fetchLists(page = 1) {
            const self = this;
            self.page = page;
            let params = {
                page: self.page,
                sortBy: self.currentOrder.sortBy,
                direction: self.currentOrder.direction
            };
            self.data_loading = true;

            axios.get(route('api.filterLists.index'), {params}).then(({data}) => {
                self.lists            = data.data;
                self.pagination          = data;
                self.data_loading        = false;
            }).catch(error => {
                self.data_loading = false;
            });
        },
        sortByColumn(sortBy) {
            const self = this;
            if (sortBy === self.currentOrder.sortBy) {
                self.currentOrder.direction = (self.currentOrder.direction === 'asc') ? 'desc' : 'asc'
            } else {
                self.currentOrder.sortBy = sortBy
                self.currentOrder.direction = 'desc';
            }
            this.fetchLists();
        },
        listDetail(list) {
            window.location = route('list-detail', {list: list.id});
        },
        fixUpdatedDate(updatedAt){
            return moment.utc(updatedAt).local().format('MMM D YYYY, h:mm A')
        },
    }
}
</script>

<style scoped>
tr {
    line-height: 2rem;
}
.pagination > li > a {
    color: #4dc0b5;
}

.pagination > li > a:hover {
    background-color: #4dc0b5 !important;
    color: white;
}

.bg-qualified {
    background-color: #00ff8f;
}

li.page-item.active > a {
    background-color: #4dc0b5 !important;
    border-color: #4dc0b5 !important;
}

a.page-link:focus {
    box-shadow: none;
}

.project-listing-dropdown-button {
    border-color: #14b1af !important;
    color: #14b1af !important;
}

.overflowStyle {
    overflow: auto;
}

.custom-height-class {
    height: 150px;
}

.project-listing-dropdown-button:hover,
.project-listing-dropdown-button:active,
.project-listing-dropdown-button:focus,
.project-listing-dropdown-button:visited,
.project-listing-dropdown-button:focus-visible,
.project-listing-dropdown-button:focus-within,
.project-listing-dropdown-button:target,
.project-listing-dropdown-button .show > .btn-outline-success.dropdown-toggle {
    border-color: #14b1af !important;
    color: #ffffff !important;
    background-color: #14b1af !important;
    box-shadow: none !important;
}

.add-view-button {
    font-size: 13px;
    color: #14b1af;
    margin: 8px;
    outline: unset;
}

.bulk-update-button {
    font-size: 15px;
    font-weight: normal;
    color: #14b1af;
}

tr:hover > td > span > input,
tr:hover > td > div > span > select,
tr:hover > td > div > span > input,
tr:hover > td > span > div > div > input,
tr:hover > td > div > span > div > div > input {
    background-color: #f1f5f8 !important;
}

tr > td > span > div.required-field-missing > input,
tr:hover > td > span > div.required-field-missing > input {
    background-color: #F78580 !important;
}

.required-field-missing {
    background: #F78580;
}

#project_index .fix-name-content {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 10vw !important;
    display: block;
}

.inline_update_loading_class {
    position: absolute;
    top: 50%;
    left: 50%;
}

#project_index {
    border-collapse: collapse;
    border-spacing: 0px;
    overflow: scroll;
}

#project_index th.column-header-resize {
    padding: 0;
    margin: 0px;
}

#project_index th.column-header-resize div.column-resize {
    resize: horizontal;
    overflow: auto;
    min-width: 90%;
    margin: 0px;
    padding: 0px;
    display: block;
    border: 0;
}

#project_index td.td-text-overflow {
    overflow: hidden;
}

.pin-black {
    font-size: 16px !important;
}

.pin-red {
    font-size: 16px !important;
    color: red !important;;
}

.pin-project-highlighted {
    background-color: #fff5eb;
}
.custom-checkbox.check_current_checkbox{
    margin-left: 7px !important;
}
.custom-checkbox.check_current_checkbox2{
    margin-left: 16px !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #0068f8 !important;
    border-color: #0068f8 !important;
}
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    select {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    #project_index .fix-name-content {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }
}

@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    select {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    #project_index .fix-name-content {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }
}

.tooltip-inner {
    width: 100% !important;
    max-width: 700px;
    height: auto;
}
</style>
